import { IImageTile } from "@faire/web-api--source/indigofair/data/IImageTile";
import { CIRCLE_TILE_WIDTH_PIXELS } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/sharedStylingConsts";
export var useResponsiveTileWidth = function(imageTileVariant) {
    if (imageTileVariant === IImageTile.ImageTileVariant.CIRCLE_TILE || imageTileVariant === IImageTile.ImageTileVariant.SMALL_CIRCLE_TILE) {
        return CIRCLE_TILE_WIDTH_PIXELS;
    }
    return {
        mobileAndAbove: 0
    };
};
